// src/hooks/useAccessLevels.js
import { useEffect, useState } from "react";
import {
  getRoles,
  getAccessTree,
  getRolePermissions,
  saveRole,
  saveRolePermissions,
} from "../api/accessLevelsApi";
import usePermissionTree from "./usePermissionTree";
import { toast } from "react-toastify";

export default function useAccessLevels() {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [search, setSearch] = useState("");
  const [rawTree, setRawTree] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    tree,
    checked,
    expanded,
    toggleModule,
    toggleAction,
    toggleExpand,
    setCheckedFromIds,
    getSelectedPayload,
    setTree,
  } = usePermissionTree(rawTree);

  // ==========================
  // CARGAR ROLES
  // ==========================
  const loadRoles = async () => {
    try {
      const data = await getRoles();
      setRoles(data);
    } catch (err) {
      console.error(err);
      toast.error("Error cargando roles");
    }
  };

  // ==========================
  // CARGAR ARBOL
  // ==========================
  const loadTree = async () => {
    try {
      const t = await getAccessTree();
      setRawTree(t);
      setTree(t);
    } catch (err) {
      console.error(err);
      toast.error("Error cargando módulos");
    }
  };

  // ==========================
  // CARGAR PERMISOS DE UN ROL
  // ==========================
  const selectRole = async (role) => {
    setSelectedRole(role);

    try {
      const acciones = await getRolePermissions(role.id);

      const ids = acciones.map((a) => Number(a.accion_id));

      setCheckedFromIds(ids);
    } catch (err) {
      console.error(err);
      toast.error("Error cargando permisos del rol");
    }
  };

  // ==========================
  // GUARDAR PERMISOS
  // ==========================
  const savePermissions = async () => {
    if (!selectedRole) {
      toast.error("Seleccione un rol");
      return;
    }

    setLoading(true);
    const payload = getSelectedPayload();

    try {
      const resp = await saveRolePermissions(selectedRole.id, payload);

      if (resp.success) {
        toast.success("Permisos guardados");
      } else {
        toast.error("Error guardando permisos");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error de conexión");
    }

    setLoading(false);
  };

  // ==========================
  // GUARDAR / ACTUALIZAR ROL
  // ==========================
  const saveRoleData = async (data) => {
    try {
      const resp = await saveRole(data);
      return resp;
    } catch (err) {
      console.error(err);
      toast.error("Error guardando nivel");
      return { success: false };
    }
  };

  return {
    roles,
    selectedRole,
    search,
    tree,
    checked,
    expanded,
    loading,

    setSearch,
    toggleModule,
    toggleAction,
    toggleExpand,

    loadRoles,
    loadTree,
    selectRole,
    savePermissions,
    saveRoleData,
  };
}
